import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CubeOutline = function CubeOutline(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m9.75 20.7501 1.473.8183c.2836.1576.4254.2363.5756.2672a1 1 0 0 0 .4029 0c.1501-.0309.2919-.1096.5755-.2672l1.473-.8183m-9-2.5-1.427-.7928c-.2995-.1664-.4493-.2496-.5584-.368a1 1 0 0 1-.2141-.3639C3 16.5726 3 16.4013 3 16.0586v-1.5585m0-5V7.9415c0-.3426 0-.514.0505-.6667a1 1 0 0 1 .2141-.364c.109-.1183.2588-.2015.5584-.368l1.427-.7927m4.5-2.5 1.473-.8183c.2836-.1576.4254-.2364.5756-.2673a1 1 0 0 1 .4029 0c.1501.031.2919.1097.5755.2673l1.473.8183m4.5 2.5 1.427.7928c.2996.1664.4493.2496.5584.368a1 1 0 0 1 .2141.3639c.0505.1528.0505.324.0505.6667v1.5586m0 5v1.5585c0 .3427 0 .514-.0505.6668a1 1 0 0 1-.2141.3639c-.1091.1184-.2588.2016-.5584.368l-1.427.7928m-9-7.5 2.25 1.25m0 0 2.25-1.25m-2.25 1.25v2.5m-9-7.5 2.25 1.25m13.5 0L21 7m-9 12.5V22"
    })
  }));
};
export default CubeOutline;